import { CommodityViewModel } from '@models/commodities.class';
import {
  BaseCommodityAdapter,
  CommodityCommodity,
  CommodityGroups,
  CurrencyCommodity,
  IndexCommodity,
} from './solaceCommoditiesType.class';

export class CommoditiesFactory {
  makeCommodity(
    type: CommodityGroups,
    commodity: CommodityViewModel,
  ): BaseCommodityAdapter {
    switch (type) {
      case CommodityGroups.indexes:
        return new IndexCommodity(commodity);

      case CommodityGroups.commodities:
        return new CommodityCommodity(commodity);

      case CommodityGroups.rates:
      case CommodityGroups.currencies:
        return new CurrencyCommodity(commodity);
      default:
        break;
    }
  }
}
